
export class ConnectedUserModel {
  userId: string|null;
  isSupportAccount: boolean;
}
